// `crypto.randomUUID` only exists from Chrome 92 / Safari 15.4. The build
// targets es2020, which downlevels syntax but polyfills no built-in, so the
// call reaches older engines as-is: Shaka asks `window.crypto.randomUUID()`
// for its session id from its media event listeners (SHORTS-WEB-7Y, the
// project's largest "is not a function" issue), and `UpsellFlow` builds its
// idempotency key with it. Shaka ships its own version, but only behind
// `shaka.polyfill.installAll()`, which we never call — and it would not cover
// the upsell anyway.
//
// Built on `crypto.getRandomValues`, which every engine we reach has.
// Installed on `crypto` itself rather than rewritten at the call sites, so the
// dependency is covered too. Imported first in src/main.tsx.
//
// No-op on engines that already implement it, and on those without
// `crypto.getRandomValues`: this is the app's first import, a throw here would
// blank the page before Sentry boots.

function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

if (
  typeof crypto !== "undefined" &&
  typeof crypto.getRandomValues === "function" &&
  !("randomUUID" in crypto)
) {
  Object.defineProperty(crypto, "randomUUID", {
    value: randomUUID,
    writable: true,
    enumerable: false,
    configurable: true,
  });
}

// A file with no import or export is a script to TypeScript, which the unit
// test can't `import()`.
export {};
